'use client'

import {useEffect} from 'react'
import classnames from 'classnames'

import {useModalsContext} from '../../../hooks/useModalContext'
import {Modal} from '../Modal'
import {BeforeRegModalCard, ModalCard} from './components/ModalCard'

import styles from './styles.module.css'
export type BeforeRegModalProps = {
  id: string
  isOpen?: boolean
  title: string
  cards: BeforeRegModalCard[]
  onClose?: () => void
}

export function BeforeRegModal({id, title, cards, isOpen, onClose: onCloseExternal}: BeforeRegModalProps) {
  const {state, dispatch} = useModalsContext()
  useEffect(() => {
    if (isOpen) {
      dispatch({type: 'setOpen', payload: id})
    } else {
      dispatch({type: 'setClose', payload: id})
    }
  }, [dispatch, id, isOpen])

  return (
    <Modal
      id={id}
      isModalOpen={state[id]?.isOpen || false}
      modalClassName={classnames(styles.popup)}
      onClose={() => {
        dispatch({type: 'setClose', payload: id})
        onCloseExternal?.()
      }}
      title={title}
      type="popupBottom"
    >
      <div className={classnames(styles.cardContainer)}>
        {cards.map(card => (
          <ModalCard
            key={card.title}
            buttons={card.buttons}
            icon={card.icon}
            options={card.options}
            title={card.title}
          />
        ))}
      </div>
    </Modal>
  )
}
